import { createContext, useContext } from 'react';

export interface ReportData {
    reportIds: Record<string, string>;
    reportTitles: Record<string, string>;
    loading: boolean;
}

export const ReportContext = createContext<ReportData | undefined>(undefined);

export const useReport = () => {
    const context = useContext(ReportContext);
    if (context === undefined) {
        throw new Error('useReport must be used within a ReportProvider');
    }
    return context;
};

